import { OreHeading, OreStack, OreStepper } from "@edenredespana/oreneta"
import { LoginTranslation } from "../accountTranslation"
import { useTranslation } from "react-i18next"
import { RegisterStepTwo, TokenErrorPage } from "../molecules"
import { RegisterSteps } from "@/Account/domain"
import { useBasicformController } from "../hooks"
import { createRegisterRepository } from "@/Account/infrastructure/ApiRegisterRepository"

export const StepTwo = (): JSX.Element => {
  const { t } = useTranslation()
  const { form, save, showErrror, mandatoryFields, showErrorPage, downloadPublicDocument, registerOrigin, isNursery, isServerError } = useBasicformController(createRegisterRepository())
  return (
    <OreStack style={{ maxWidth: '900px' }}>
      <>
        {showErrorPage ? (<TokenErrorPage registerOrigin={registerOrigin} isNursery={isNursery} isServerError={isServerError} />) : (
          <>
            <OreHeading as="h1" size="headline-lg">
              {t(LoginTranslation.register.heading)}
            </OreHeading>
            <>
              <OreStepper
                activeStep={RegisterSteps.CreateAccount}
                steps={[
                  t(LoginTranslation.register.step1),
                  t(LoginTranslation.register.step2),
                  t(LoginTranslation.register.step3),
                ]}
              />
              <RegisterStepTwo form={form} mandatoryFields={mandatoryFields} save={save}
                showErrorPage={showErrorPage} showErrror={showErrror} downloadPublicDocument={downloadPublicDocument} />
            </>
          </>
        )}
      </>
    </OreStack>
  )
}